import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useCreateBankTransferChallenge,
  useVerifyBankTransferStatus,
} from "@hooks/index";
import { BankTransactionStatus } from "@interfaces";
import { useSnackbar } from "notistack";
import { tracker } from "@utils/openreplay";
import { getEnrolmentErrorDisplay } from "../hooks/onQuestionChallengeError";
import { BankTransferFailureScreen } from "./BankTransferFailureScreen";

const SOURCE = "CanceledBankTransferScreen";

export const CanceledBankTransferScreen: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const { data: transferStatusData, error: errorGettingTransactionStatus } =
    useVerifyBankTransferStatus();

  const { mutateAsync: createChallengeRequest } = useCreateBankTransferChallenge({
    onError: (error) => {
      setIsLoading(false);
      tracker?.event("BankTransferChallengeRequestedError", {
        source: SOURCE,
        error: error,
        errorMessage: error.message,
      });
      enqueueSnackbar(getEnrolmentErrorDisplay(error).name, {
        variant: "error",
      });
    },
  });

  const handleRetry = useCallback(async () => {
    setIsLoading(true);
    await createChallengeRequest();
  }, [createChallengeRequest]);

  useEffect(() => {
    tracker?.event("BankTransferChallengeCanceled", { source: SOURCE });
  }, []);

  useEffect(() => {
    if (transferStatusData?.bankTransferStatus === BankTransactionStatus.APPROVED) {
      navigate("/app/registro/firma-electronica-avanzada/transferencia-bancaria/exito");
    }
  }, [transferStatusData?.bankTransferStatus, navigate]);

  useEffect(() => {
    if (errorGettingTransactionStatus) {
      tracker?.event("BankTransferChallengeStatusError", {
        source: SOURCE,
        error: errorGettingTransactionStatus,
        errorMessage: errorGettingTransactionStatus?.message,
      });
    }
  }, [errorGettingTransactionStatus]);

  return (
    <BankTransferFailureScreen
      source={SOURCE}
      onRetry={handleRetry}
      isRetrying={isLoading}
    />
  );
};
